export default __webpack_public_path__ + "static/media/logo_admin.b1d487b4.png";